import React, { useState } from 'react';
import { MailIcon, MessageSquareIcon } from 'lucide-react';
interface ContactProps {
  openCalendly: () => void;
}
export const Contact = ({
  openCalendly
}: ContactProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    const formData = new FormData(e.currentTarget);
    const data = {
      name: formData.get('name'),
      email: formData.get('email'),
      message: formData.get('message'),
      access_key: '6f95729a-8a4e-4843-8cf3-6ae5a171fbe9'
    };
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      if (response.ok) {
        setSubmitSuccess(true);
        e.currentTarget.reset();
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      setIsSubmitting(false);
    }
  };
  return <section id="contact" className="w-full py-20 px-6 md:px-12 bg-indigo-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Let's Discuss Your Growth Goals
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Ready to take your marketing to the next level? Get in touch to
            schedule a free strategy call.
          </p>
        </div>
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="lg:w-1/2">
            <form onSubmit={handleSubmit} className="bg-white p-8 rounded-lg shadow-sm">
              {submitSuccess ? <div className="text-center py-8">
                  <h4 className="text-xl font-semibold text-gray-800 mb-2">
                    Message Sent!
                  </h4>
                  <p className="text-gray-600">
                    Thanks for reaching out. I'll get back to you soon.
                  </p>
                </div> : <>
                  <div className="mb-6">
                    <label htmlFor="name" className="block text-gray-700 mb-2">
                      Your Name
                    </label>
                    <input type="text" id="name" name="name" required className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent" placeholder="John Doe" />
                  </div>
                  <div className="mb-6">
                    <label htmlFor="email" className="block text-gray-700 mb-2">
                      Email Address
                    </label>
                    <input type="email" id="email" name="email" required className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent" placeholder="john@example.com" />
                  </div>
                  <div className="mb-6">
                    <label htmlFor="message" className="block text-gray-700 mb-2">
                      Tell me about your goals
                    </label>
                    <textarea id="message" name="message" required rows={5} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent" placeholder="I'm looking to improve our email marketing and lead generation..."></textarea>
                  </div>
                  <button type="submit" disabled={isSubmitting} className="w-full bg-indigo-600 text-white py-3 rounded-md font-medium hover:bg-indigo-700 transition-colors disabled:opacity-75">
                    {isSubmitting ? 'Sending...' : 'Send Message'}
                  </button>
                </>}
            </form>
          </div>
          <div className="lg:w-1/2">
            <div className="bg-white p-8 rounded-lg shadow-sm h-full">
              <h3 className="text-2xl font-bold text-gray-800 mb-6">
                Other Ways to Connect
              </h3>
              <div className="space-y-8">
                <div className="flex items-start">
                  <div className="bg-indigo-100 p-3 rounded-full mr-4">
                    <MailIcon size={24} className="text-indigo-600" />
                  </div>
                  <div>
                    <h4 className="text-lg font-medium text-gray-800 mb-1">
                      Email
                    </h4>
                    <p className="text-gray-600 mb-2">
                      For inquiries and questions
                    </p>
                    <a href="mailto:wcs@jackcarlsoncopy.com" className="text-indigo-600 hover:underline">
                      wcs@jackcarlsoncopy.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="bg-indigo-100 p-3 rounded-full mr-4">
                    <MessageSquareIcon size={24} className="text-indigo-600" />
                  </div>
                  <div>
                    <h4 className="text-lg font-medium text-gray-800 mb-1">
                      Schedule a Call
                    </h4>
                    <p className="text-gray-600 mb-2">
                      Book a free 30-minute strategy call
                    </p>
                    <button onClick={openCalendly} className="text-indigo-600 hover:underline">
                      Select a time on my calendar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};